import { useState } from "react";
import { Card } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { Input } from "../../components/ui/Input";
import { apiClient } from "../../lib/api-client";

export default function SuperadminToolsPage() {
  return (
    <>
      <PageDiscoveryTool />
      <LeadInspector />
    </>
  );
}

function PageDiscoveryTool() {
  const [token, setToken] = useState("");
  const [result, setResult] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setBusy(true); setError(null); setResult(null);
    try {
      const res = await apiClient.post("/api/superadmin/meta/pages/discover", { json: { long_lived_token: token } });
      setResult(res);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card title="Page discovery" subtitle="Paste a long-lived user token to see every reachable Page.">
      <div className="form-stack">
        <Input label="Long-lived user token" value={token} onChange={(e) => setToken(e.target.value)} />
        <div>
          <Button onClick={run} disabled={!token || busy}>{busy ? "Running…" : "Discover"}</Button>
        </div>
        {error ? <div className="form-error">{error}</div> : null}
        {result ? <pre className="codeblock">{JSON.stringify(result, null, 2)}</pre> : null}
      </div>
    </Card>
  );
}

function LeadInspector() {
  const [leadgenId, setLeadgenId] = useState("");
  const [token, setToken] = useState("");
  const [result, setResult] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setBusy(true); setError(null); setResult(null);
    try {
      const res = await apiClient.get(`/api/superadmin/meta/leads/${leadgenId}`, {
        params: { page_access_token: token },
      });
      setResult(res);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card title="Lead inspector" subtitle="Fetch one lead from Graph API for diagnostics.">
      <div className="form-stack">
        <Input label="leadgen_id" value={leadgenId} onChange={(e) => setLeadgenId(e.target.value)} />
        <Input label="Page access token" value={token} onChange={(e) => setToken(e.target.value)} />
        <div>
          <Button onClick={run} disabled={!leadgenId || !token || busy}>{busy ? "Fetching…" : "Fetch"}</Button>
        </div>
        {error ? <div className="form-error">{error}</div> : null}
        {result ? <pre className="codeblock">{JSON.stringify(result, null, 2)}</pre> : null}
      </div>
    </Card>
  );
}
